import { TabsManager } from 'uiKit/TabsManager';
import { Tab } from 'modules/common/hooks/useTabs';

import { useSecondaryTabsStyles } from './SecondaryTabsStyles';

export interface SecondaryTabsProps<TabID> {
  className?: string;
  classNameTab?: string;
  classNameTabsInner?: string;
  classNameTabsWrapper?: string;
  selectedTab?: Tab<TabID>;
  tabs: Tab<TabID>[];
  visible?: boolean;
}

export function SecondaryTabs<TabID>({
  className,
  classNameTab,
  classNameTabsInner,
  classNameTabsWrapper,
  selectedTab,
  tabs,
  visible = true,
}: SecondaryTabsProps<TabID>) {
  const { classes, cx } = useSecondaryTabsStyles();

  return visible && tabs.length > 0 ? (
    <TabsManager
      allowSingleTab
      className={cx(classes.secondaryTabs, className)}
      classNameTab={classNameTab}
      classNameTabsInner={classNameTabsInner}
      classNameTabsWrapper={classNameTabsWrapper}
      selectedTab={selectedTab}
      tabs={tabs}
    />
  ) : null;
}
